import { ITicker, enums } from '@kattana-io/common';

/**
 * Returns data of ticker
 * Included flipped logic
 */

export interface ITickerDisplayData {
  name: string;
  price: number;
  price_usd: number;
  change: number;
  change_usd: number;
  chain: string;
  base: string;
  quote: string;
  base_decimals: number;
  base_address: string;
  quote_decimals: number;
  quote_address: string;
  base_slug?: string;
  quote_slug?: string;
  exchange: string;
  id: number;
  quoteIsStablecoin: boolean;
  isDEX: boolean;
  base_reserve: number;
  quote_reserve: number;
}

const useTicker = (ticker: ITicker): ITickerDisplayData => {
  const isDEX = ticker.kind == enums.ETickerKind.DEX;

  if (ticker.flipped) {
    const [quote, base] = ticker.name.split('/');
    return {
      name: `${base}/${quote}`,
      price: ticker.price_b,
      price_usd: ticker.price_b_usd,
      change: ticker.change_b,
      change_usd: ticker.change_b_usd,
      chain: ticker.chain,
      base,
      quote,
      base_decimals: ticker.quote_decimals,
      quote_decimals: ticker.base_decimals,
      base_address: ticker.quote_address,
      quote_address: ticker.base_address,
      base_slug: (ticker as any).quote_slug,
      quote_slug: (ticker as any).base_slug,
      exchange: ticker.exchange,
      id: ticker.id,
      quoteIsStablecoin: quote?.includes('USD'),
      isDEX,
      base_reserve: ticker.quote_reserve,
      quote_reserve: ticker.base_reserve,
    };
  }

  const [base, quote] = ticker.name.split('/');
  return {
    name: ticker.name,
    price: ticker.price_a,
    price_usd: ticker.price_a_usd,
    change: ticker.change_a,
    change_usd: ticker.change_a_usd,
    chain: ticker.chain,
    base,
    quote,
    base_decimals: ticker.base_decimals,
    quote_decimals: ticker.quote_decimals,
    base_address: ticker.base_address,
    quote_address: ticker.quote_address,
    base_slug: (ticker as any).base_slug,
    quote_slug: (ticker as any).quote_slug,
    exchange: ticker.exchange,
    id: ticker.id,
    quoteIsStablecoin: quote?.includes('USD'),
    isDEX,
    base_reserve: ticker.base_reserve,
    quote_reserve: ticker.quote_reserve,
  };
};

export default useTicker;
